import axiosInstance from '@/service/helpers/axios'
export async function getProfile() {
  const result = await axiosInstance.get('/content-contributor/profile')
  return result
}
export async function updateContributor(contributor: {
  fullname: string | undefined
  email: string | undefined
  gender: string | undefined
  short_bio: string | undefined
  instagram: string | undefined
  linkedin: string | undefined
  twitter: string | undefined
  link_others: string | undefined
  tiktok: string | undefined
  youtube: string | undefined
}) {
  const result = await axiosInstance.post('/content-contributor/profile', contributor)
  return result
}

export async function updateContributorThumbnail(body: {
  thumbnail: null | Dropzone.DropzoneFile
}) {
  const result = await axiosInstance.post(`/content-contributor/update-thumbnail`, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result
}
